module.exports = __webpack_public_path__ + "img/u78.87cb5de1.jpg";